var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvFavoriteOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7287 2.21471C12.462 2.30004 13 2.93271 13 3.67137V14L8 11.5L3 14V3.67137C3 2.93271 3.53733 2.30004 4.27133 2.21471C6.74879 1.92713 9.25121 1.92713 11.7287 2.21471Z",
    stroke: "#D53E20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvFavoriteOrange);
export default __webpack_public_path__ + "static/media/cv-favorite-orange.5b4c11d30ff0da9b361fef80f8988244.svg";
export { ForwardRef as ReactComponent };